import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/orders`, {params})
    },
    checkNew(){
        return Vue.axios.get(`/orders/check-new`)
    },
    update(id, params) {
        return Vue.axios.post(`/orders/update/${id}`, params)
    },
    updatePayStatus(id) {
        return Vue.axios.get(`/orders/update/${id}/pay-status`)
    },
    setOpen(id) {
        return Vue.axios.get(`/orders/set-open/${id}`)
    },
    cancel(id) {
        return Vue.axios.get(`/orders/${id}/cancel/np`)
    },
    generateShippingNote(id) {
        return Vue.axios.get(`/orders/${id}/generate/shipping-note`)
    },
    toggleIsProcessed(id) {
        return Vue.axios.get(`/orders/toggle-is-processed/${id}`)
    },
    toggleIsPaid(id) {
        return Vue.axios.get(`/orders/toggle-is-paid/${id}`)
    },
    sendToIiko(id) {
        return Vue.axios.get(`/orders/send-to-iiko/${id}`)
    },
    getSources() {
        return Vue.axios.get(`/orders/sources`)
    }
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
